var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAptdecoLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "AptDeco Homepage",
    width: 48,
    height: 35,
    viewBox: "0 0 48 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.255 16.077L9.349 5.852l4.104 10.225H6.255zm15.572 1.008c-.404-.964-.83-1.972-1.277-3.028a542.27 542.27 0 0 1-1.329-3.143 300.253 300.253 0 0 1-1.245-3.01c-.392-.964-.757-1.85-1.092-2.657a11.756 11.756 0 0 0-.808-1.58 7.325 7.325 0 0 0-1.227-1.53A6.39 6.39 0 0 0 13.167.992C12.528.69 11.793.538 10.964.538H4.877v.268c.38 0 .773.152 1.177.455.402.302.795.68 1.177 1.127.381.45.734.936 1.059 1.463.324.527.611 1.002.858 1.43L4.002 22.266a1.99 1.99 0 0 1-.824 1.126c-.416.281-.836.421-1.261.421H0v.268h7.028v-.268H5.247c-.315 0-.539-.084-.673-.254a.957.957 0 0 1-.202-.622v-.218c0-.079.01-.15.034-.219l1.748-6.154h7.434c.47 1.167.941 2.226 1.412 3.178s1.026 1.766 1.664 2.437a6.703 6.703 0 0 0 2.254 1.564c.863.371 1.912.556 3.145.556h2.725a2385.83 2385.83 0 0 1-2.961-6.996z",
    fill: "#FF5F3D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAptdecoLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aptdeco-logo.92fa4c6f080536bb3b6a7d0014cf19ce.svg";